var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://api.invoice.kaynex.com';
} else {
    service.API_URL = 'http://192.168.1.81:5000';
}

export default service;
